import React from "react"



export default class SelectConferenceYear extends React.Component{
  constructor(props){
    super(props);

    const yearOptions = this.buildAwardDisplay(props.years, props.handleClick)

    this.state = {
      yearOptions: yearOptions,
    }
  }

  buildAwardDisplay(years, handler){
    return (
      <select style={{width:"100%"}} onChange={handler}>
        {years.sort().reverse().map(a => (<option key={a} value={a}>{a}</option>))}
      </select>
    )
  }


  render(){
    return(
      <div
      className="col-md-1">
        <form>
          <label>
            Select Year
            <div>
              {this.state.yearOptions}
            </div>
          </label>
        </form>
      </div>
    )
  }

}
